<template>
  <div class="pw-new-grid-pagination">
    <div
      class="paginator-item"
      :class="{ 'paginator-item--disabled': currentPage === 1 }"
      @click="goToStart"
    >
      <i class="mdi mdi-chevron-double-left"></i>
    </div>
    <div
      class="paginator-item"
      :class="{ 'paginator-item--disabled': currentPage === 1 }"
      @click="modifyCurrentPage(1, false)"
    >
      <i class="mdi mdi-chevron-left"></i>
    </div>
    <div
      class="paginator-item"
      @click="nextGroup(maxPageItems, false)"
      v-if="currentTop > maxPageItems"
    >
      ...
    </div>
    <div
      class="paginator-item"
      v-for="i in pageCounter"
      :key="i + group"
      :class="{ 'paginator-item--current-page': currentPage === i + group }"
      @click="changePage(i + group)"
    >
      {{ i + group }}
    </div>
    <div
      class="paginator-item"
      @click="nextGroup(maxPageItems, true)"
      v-if="currentTop < pageNumbers"
    >
      ...
    </div>
    <div
      class="paginator-item"
      :class="{ 'paginator-item--disabled': currentPage === pageNumbers }"
      @click="modifyCurrentPage(1, true)"
    >
      <i class="mdi mdi-chevron-right"></i>
    </div>
    <div
      class="paginator-item"
      :class="{ 'paginator-item--disabled': currentPage === pageNumbers }"
      @click="goToEnd"
    >
      <i class="mdi mdi-chevron-double-right"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PwNewGridPagination',
  props: {
    totalItems: Number,
    pageSize: Number,
  },
  data() {
    return {
      currentPage: 1,
      maxPageItems: 10,
      group: 0,
    };
  },
  methods: {
    goToStart() {
      this.group = 0;
      this.currentPage = 1;
    },
    goToEnd() {
      this.currentPage = this.pageNumbers;
      this.group = Math.floor(this.pageNumbers / this.maxPageItems) * this.maxPageItems;
    },
    changePage(page) {
      this.currentPage = page;
    },
    nextGroup(number, isAdded) {
      this.group += isAdded ? number : number * -1;
      this.currentPage = isAdded ? this.group + 1 : this.group + this.maxPageItems;
    },
    modifyCurrentPage(number, isAdded) {
      this.currentPage += isAdded ? number : number * -1;
      if (this.currentPage > this.currentTop) {
        this.group += this.maxPageItems;
      } else if (this.currentPage === this.currentTop - 10) {
        this.group -= this.maxPageItems;
      }
    },
  },
  computed: {
    currentTop() {
      return this.group + this.maxPageItems;
    },
    pageCounter() {
      if (this.pageNumbers > this.maxPageItems) {
        if (this.currentTop >= this.pageNumbers) {
          return this.pageNumbers - (this.currentTop - 10);
        }
        return this.maxPageItems;
      }
      return this.pageNumbers;
    },
    pageNumbers() {
      return Math.ceil(this.totalItems / this.pageSize);
    },
  },
  watch: {
    currentPage(val) {
      this.$emit('onChangePage', val);
    },
  },
};
</script>

<style lang="scss">
.pw-new-grid-pagination {
  display: flex;
  margin-top: 16px;
}
.paginator-item {
  min-width: 32px;
  min-height: 32px;
  padding: 0 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #a4afb7;
  border-radius: 3px;
  color: #a4afb7;
  margin-right: 8px;
  background-color: #fff;
  cursor: pointer;
  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  &--current-page {
    border-color: #6ae1c8;
    background-color: #6ae1c8;
    color: #fff;
  }
}
</style>
